export const ENTITY_TAB_EMAILS_MESSAGE_MODAL_QA_NAME =
  'entityTabEmailsMessageModal'
